<template>
  <v-container>
    <v-toolbar
      flat
      color="primary"
      role="heading"
      aria-level="1"
      :aria-label="$t('components.transactions.title')"
    >
      <v-toolbar-title>
        {{ $t('components.transactions.title') }}
      </v-toolbar-title>
      <v-spacer />
    </v-toolbar>

    <!-- Data table -->
    <v-card>
      <v-data-table
        :headers="headers"
        :items="transactionsFormatted"
        :loading="isLoading"
        :items-per-page="15"
        loading-text="Loading... Please wait"
        no-results-text="No transactions were found"
        no-data-text="No data was found"
        item-key="orderId"
        class="elevation-1"
        sort-by="created"
        group-desc
        color="secondary"
        aria-live="polite"
        :aria-busy="isLoading"
        :aria-label="$t('components.transactions.title')"
        :footer-props="{
          showFirstLastPage: true,
          firstIcon: 'fad fa-chevron-double-left',
          lastIcon: 'fad fa-chevron-double-right',
          prevIcon: 'fad fa-chevron-left',
          nextIcon: 'fad fa-chevron-right'
        }"
      >
        <!-- Loading bar (visual only, state announced by aria-busy above) -->
        <template #progress>
          <v-progress-linear
            v-show="isLoading"
            color="accent"
            indeterminate
            aria-hidden="true"
          />
        </template>

        <template #body="{ items }">
          <tbody>
            <tr
              v-for="item in items"
              :key="item.orderId"
            >
              <td>{{ item.orderId || '0' }}</td>
              <td>{{ item.transactionId || 'No transaction ID' }}</td>
              <td>{{ item.price || 0 }}</td>
              <td>{{ item.points || 0 }}</td>
              <td>{{ item.provider || 'Unknown' }}</td>
              <td>{{ item.status || 'Failed' }}</td>
              <td>{{ item.created || 'Unknown' }}</td>
              <td>
                <a
                  v-if="item.pdfLink"
                  :href="item.pdfLink"
                  target="_blank"
                  rel="noopener"
                  role="link"
                  :aria-label="`${$t('components.transactions.download')} - ${item.orderId}`"
                  class="link-accent"
                >
                  {{ $t('components.transactions.download') }}
                </a>
                <span
                  v-else
                  class="text-body-2"
                >
                  {{ $t('components.transactions.unavailable') }}
                </span>
              </td>
            </tr>
          </tbody>
        </template>
      </v-data-table>
    </v-card>
  </v-container>
</template>

<script>
import { getHeaders, toTransactions } from "@/utils/transactions.utils";

export default {
  name: "Transactions",
  data() {
    return {
        search: '',
        transactions: [],
        headers: getHeaders(),
        isLoading: false
    }
  },
  computed: {
    transactionsFormatted() {
      // get our config for payments
      const config = this.$store.getters.config("payments") || {};
      // transform orders into our table data
      return toTransactions(
        config.statuses,
        config.currency,
        this.transactions
      );
    }
  },
  beforeMount() {
    this.isLoading = true;
    this.$api.getTransactions()
      .then(transactions => {
        this.isLoading = false;
        this.transactions = transactions;
      })
      .catch(() => {
        this.isLoading = false;
      });
  },
  methods: {}
};
</script>
